import React from 'react'
import { IoMdCheckmarkCircleOutline, IoMdCloseCircleOutline } from 'react-icons/io'

interface PlanBenefitsProps {
  className?: string
  style?: React.CSSProperties
  title: string
  benefits: string[]
  planName: string
  dark?: boolean
}

const PlanBenefits = ({ style, title, planName, benefits, dark = false }: PlanBenefitsProps) => {
  return (
    <div style={{ ...style }}>
      <div className='flex flex-col gap-1'>
        <p className='text-sm text-inherit font-medium'>{title}</p>

        <div>
          {benefits.map((benefit, index) => {
            const isUnavailable = planName.includes('MEI') && index < 2

            return (
              <div key={index} className='flex items-center gap-2 my-1'>
                <div className='w-4 h-4'>
                  {isUnavailable ? (
                    <IoMdCloseCircleOutline className={dark ? 'text-red-600' : 'text-red-400'} />
                  ) : (
                    <IoMdCheckmarkCircleOutline className={dark ? 'text-green-600' : 'text-green-400'} />
                  )}
                </div>

                <p className='text-sm leading-6'>{benefit}</p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default PlanBenefits
